'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiWeatherWindy = function TiWeatherWindy(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31.7 8.3c-1 0-1.7 0.8-1.7 1.7s0.7 1.7 1.7 1.7c0.9 0 1.6 0.7 1.6 1.6s-0.7 1.7-1.6 1.7h-18.4c-0.9 0-1.6 0.7-1.6 1.7s0.7 1.6 1.6 1.6h10c1 0 1.7 0.8 1.7 1.7s-0.7 1.7-1.7 1.7h-10.6c-2.8 0-5 2.2-5 5s2.2 5 5 5c0.9 0 1.6-0.8 1.6-1.7s-0.7-1.7-1.6-1.7c-1 0-1.7-0.7-1.7-1.6s0.7-1.7 1.7-1.7h10.6c2.8 0 5-2.2 5-5 0-0.6-0.1-1.1-0.3-1.7h3.7c2.7 0 5-2.2 5-5s-2.3-5-5-5z' })
        )
    );
};

exports.default = TiWeatherWindy;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/weather-windy.js
// module id = 2266
// module chunks = 0